import { render, staticRenderFns } from "./MorphologicCodeModal.vue?vue&type=template&id=2cde3b8b&scoped=true&"
import script from "./MorphologicCodeModal.ts?vue&type=script&lang=ts&"
export * from "./MorphologicCodeModal.ts?vue&type=script&lang=ts&"
import style0 from "./MorphologicCodeModal.scss?vue&type=style&index=0&id=2cde3b8b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cde3b8b",
  null
  
)

export default component.exports